module.exports = __webpack_public_path__ + "static/media/credit.8cf1aa38.svg";